// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-privacy[data-v-286c0f23] {\n  width: 100%;\n  min-height: 100vh;\n  background: #ffffff;\n}\n.container-privacy .main[data-v-286c0f23] {\n  padding: 0 16px 16px 16px;\n  color: #666666;\n  line-height: 20px;\n}", ""]);
// Exports
module.exports = exports;
